import { render, staticRenderFns } from "./GlassDetail.vue?vue&type=template&id=33608a90&"
import script from "./GlassDetail.vue?vue&type=script&lang=js&"
export * from "./GlassDetail.vue?vue&type=script&lang=js&"
import style0 from "./GlassDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports